import { useState } from "react";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useLang } from "@/context/LangContext";

export default function NewsletterForm() {
  const { t, lang } = useLang();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/newsletter", { email, lang });
      setDone(true);
      toast.success(data.already ? t("newsletter.already") : t("newsletter.ok"));
    } catch {
      toast.error(t("newsletter.err"));
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <p data-testid="newsletter-success" className="font-mono text-[10px] tracking-[0.25em] text-brass">
        {t("newsletter.thanks")}
      </p>
    );
  }

  return (
    <form data-testid="newsletter-form" onSubmit={submit} className="flex max-w-sm border border-bone/15 bg-ink">
      <input
        data-testid="newsletter-email-input"
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder={t("newsletter.placeholder")}
        className="min-w-0 flex-1 bg-transparent px-4 py-3 font-mono text-[11px] tracking-[0.15em] text-bone placeholder:text-bone-muted/60 focus:outline-none"
      />
      <button
        data-testid="newsletter-submit"
        type="submit"
        disabled={busy}
        aria-label={t("newsletter.cta")}
        className="flex items-center gap-2 border-l border-bone/15 px-4 font-mono text-[10px] tracking-[0.3em] text-brass transition-colors hover:bg-brass hover:text-ink disabled:opacity-50"
      >
        {t("newsletter.cta")} <ArrowRight size={12} />
      </button>
    </form>
  );
}
